import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './header-search-bar-suggestions-column.module.scss';
import { Conditional } from '../../../common';
export const HeaderSearchBarSuggestionsColumn = ({ children, className, displayColumn = true }) => (_jsx(Conditional, { test: displayColumn, children: _jsx("div", { className: cx(styles['header-search-bar-suggestions-column'], className ? className : ''), "data-testid": "header-searchbar-suggestions-column", children: children }) }));
